import { versionData } from './version-data'

export interface IEssetteApplicationVersion {
    major: number;
    minor: number;
    patch: number;
    name: string | null;
    code: string;
    number: string;
    version: string;
    description: string;
}

const { major, minor, patch, name } = versionData;
const full = `${major}.${minor}.${patch}${name ? '-' : ''}${name}`;
const number = `${major}.${minor}.${patch}`;
const short = `${major}.${minor}`;

export const version: IEssetteApplicationVersion = {
    ...versionData,
    number,
    version: short,
    description: full
};
